import type { SVGProps } from 'react'
import { forwardRef, useId } from 'react'

import { cn } from '~/utils/classnames'

export const Product = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, ...props }, ref) => {
    const clip0 = useId()
    const paint0 = useId()
    const paint1 = useId()
    const paint2 = useId()
    const filter0 = useId()
    const filter1 = useId()
    const filter2 = useId()

    return (
      <svg
        ref={ref}
        width="81"
        height="81"
        viewBox="0 0 81 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={cn('text-foreground', className)}
        {...props}
      >
        <path
          d="M68.8095 68.0495V68.0495C71.8948 68.0495 73.4374 68.0495 74.6818 67.6297C77.0481 66.8312 78.9059 64.9735 79.7043 62.6071C80.1242 61.3628 80.1242 59.8202 80.1242 56.7349V13.9909C80.1242 9.33023 80.1242 6.99991 79.1829 5.23515C78.436 3.83474 77.2894 2.68816 75.889 1.94124C74.1242 0.999992 71.7939 0.999992 67.1333 0.999992V0.999992H24.8076C21.3306 0.999992 19.5922 0.999992 18.2081 1.53121C16.0912 2.34372 14.4184 4.01644 13.6059 6.1334C13.0747 7.51748 13.0747 9.25593 13.0747 12.7328V12.7328"
          stroke="currentColor"
          strokeDasharray="4 4"
          opacity="0.24"
        />
        <g clipPath={`url(#${clip0})`} className="noise">
          <g opacity="0.64">
            <g opacity="0.3" filter={`url(#${filter0})`}>
              <path
                d="M4.79964 70.4235C-6.36795 78.6332 -20.7492 61.0208 -26.5438 51.1884L22.0797 8.12601C34.6465 10.2699 59.3792 22.9825 57.7755 56.6822C55.7708 98.8069 18.7591 60.1612 4.79964 70.4235Z"
                fill={`url(#${paint0})`}
              />
              <path
                d="M4.79964 70.4235C-6.36795 78.6332 -20.7492 61.0208 -26.5438 51.1884L22.0797 8.12601C34.6465 10.2699 59.3792 22.9825 57.7755 56.6822C55.7708 98.8069 18.7591 60.1612 4.79964 70.4235Z"
                stroke="currentColor"
                strokeWidth="1.03717"
              />
            </g>
            <g filter={`url(#${filter1})`}>
              <path
                d="M-8.17784 40.7504C-26.4586 47.2042 -38.5555 17.7915 -42.3189 2.2785L40.2463 -35.6145C56.1958 -27.6424 84.1371 -0.584569 68.3068 43.8693C48.519 99.4368 14.6731 32.6833 -8.17784 40.7504Z"
                fill={`url(#${paint1})`}
              />
              <path
                d="M-8.17784 40.7504C-26.4586 47.2042 -38.5555 17.7915 -42.3189 2.2785L40.2463 -35.6145C56.1958 -27.6424 84.1371 -0.584569 68.3068 43.8693C48.519 99.4368 14.6731 32.6833 -8.17784 40.7504Z"
                stroke="currentColor"
                strokeWidth="1.03717"
              />
            </g>
            <g opacity="0.4" filter={`url(#${filter2})`}>
              <path
                d="M60.3015 77.6243C53.3712 77.6243 52.7937 65.3393 53.3712 59.1968L85.7126 56.0075C90.1403 60.9687 96.339 74.4349 85.7126 88.6099C72.4295 106.329 68.9644 77.6243 60.3015 77.6243Z"
                fill={`url(#${paint2})`}
              />
              <path
                d="M60.3015 77.6243C53.3712 77.6243 52.7937 65.3393 53.3712 59.1968L85.7126 56.0075C90.1403 60.9687 96.339 74.4349 85.7126 88.6099C72.4295 106.329 68.9644 77.6243 60.3015 77.6243Z"
                stroke="currentColor"
                strokeWidth="1.03717"
              />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id={filter0}
            x="-40.8982"
            y="-6.11766"
            width="112.957"
            height="97.164"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.84534"
              result="effect1_foregroundBlur_2278_11934"
            />
          </filter>
          <filter
            id={filter1}
            x="-56.6143"
            y="-49.8802"
            width="143.829"
            height="130.266"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.84534"
              result="effect1_foregroundBlur_2278_11934"
            />
          </filter>
          <filter
            id={filter2}
            x="38.9927"
            y="41.7748"
            width="66.7979"
            height="66.8201"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="6.84534"
              result="effect1_foregroundBlur_2278_11934"
            />
          </filter>
          <linearGradient
            id={paint0}
            x1="21.6227"
            y1="45.6687"
            x2="1.39357"
            y2="86.1492"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id={paint1}
            x1="26.1556"
            y1="56.7228"
            x2="56.737"
            y2="39.7938"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id={paint2}
            x1="72.391"
            y1="64.6258"
            x2="67.1348"
            y2="99.3591"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
          <clipPath id={clip0}>
            <rect
              y="14.6209"
              width="66.379"
              height="66.379"
              rx="8.04595"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    )
  }
)

Product.displayName = 'ProductEmptyState'
